import React from 'react';
import Button from '../../forms/button';

export default function ButtonDefinition(name, text) {
	if (!(this instanceof ButtonDefinition)) {
		return new ButtonDefinition(name, text);
	}

	let type = 'full';
	let listener;
	let visible = true;
	let visibleCallback;
	let disabled = false;
	let disabledCallback;
	let minWidth;
	let margin;
	let block;

	this.setBlock = function(value) {
		block = value;
		return this;
	};

	this.setMargin = function(value) {
		margin = value;
		return this;
	};

	this.setMinWidth = function(value) {
		minWidth = value;
		return this;
	};

	this.setVisible = function(value) {
		if (typeof value === 'function') {
			visibleCallback = value;
			visible = false;
		} else {
			visible = value;
			visibleCallback = null;
		}
		return this;
	};

	this.setDisabled = function(value) {
		if (typeof value === 'function') {
			disabledCallback = value;
			disabled = false;
		} else {
			disabled = value;
			disabledCallback = null;
		}
		return this;
	};

	this.isVisible = function(ctx) {
		if (visibleCallback) {
			return visibleCallback(ctx);
		} else {
			return visible;
		}
	};

	this.isDisabled = function(ctx) {
		if (disabledCallback) {
			return disabledCallback(ctx);
		} else {
			return disabled;
		}
	};

	this.setType = function(value) {
		if (value !== 'medium' && value !== 'light') {
			value = 'full';
		}
		type = value;
		return this;
	};

	this.setListener = function(value) {
		listener = value;
		return this;
	};

	this.validateAll = function() {

	};

	this.render = function(ctx, key = 0) {
		if (!this.isVisible(ctx)) {
			return null;
		}
		return <Button
			type={type}
			key={key}
			text={text}
			name={name}
			minWidth={minWidth}
			margin={margin}
			disabled={this.isDisabled(ctx)}
			block={block}
			onAction={() => {
				if (listener) {
					listener({
						name,
						ctx
					});
				}
				ctx.trigger('action', {
					source: 'button',
					name
				});
			}}
		/>
	}
}
